import React from "react";
import "./Conduct.css";

const Conduct = () => {
  return (
    <div className="conduct-container">
      <h1>OTTOMUN Conference: Basic Code of Conduct</h1>

      <section>
        <h2>1. Preamble</h2>
        <p>
          This Code of Conduct, established by <strong>Majole International Education</strong>,
          outlines the expected standards of behavior for all participants—delegates,
          faculty advisors, staff, and volunteers—throughout the OTTOMUN Conference. Our goal is to
          foster an environment of respectful dialogue, academic integrity, and diplomatic decorum,
          in line with the spirit and principles of the United Nations.
        </p>
        <p>
          Adherence to this code is mandatory for all participants and is essential for a
          productive and prestigious conference experience.
        </p>
      </section>

      <section>
        <h2>2. General Conduct & Respect</h2>
        <ul>
          <li>
            <strong>Respect for All:</strong> All participants must treat others with dignity,
            regardless of nationality, race, religion, gender, sexual orientation, disability, or
            personal views.
          </li>
          <li>
            <strong>Professional Demeanor:</strong> Delegates must act as diplomats and use
            courteous language at all times.
          </li>
          <li>
            <strong>Zero Tolerance for Harassment:</strong> Any form of harassment, bullying, or
            intimidation is strictly prohibited.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Committee Session Etiquette</h2>
        <ul>
          <li><strong>Formal Language</strong> is required when speaking.</li>
          <li>Delegates may only speak when <strong>recognized by the Chair</strong>.</li>
          <li>Points must be used appropriately according to OTTOMUN Rules of Procedure.</li>
          <li>No cross-talking; all debate flows through the Chair.</li>
          <li><strong>Western Business Attire</strong> is mandatory.</li>
        </ul>
      </section>

      <section>
        <h2>4. Academic Integrity & Document Preparation</h2>
        <p>
          Plagiarism of any kind is strictly prohibited. Delegates must research and represent the
          official policy of their assigned country faithfully.
        </p>

        <h3>4.1 Working Paper (WP)</h3>
        <ul>
          <li>First-stage draft of solutions.</li>
          <li>No sponsors required.</li>
          <li>Must be approved by the dais before becoming a resolution.</li>
        </ul>

        <h3>4.2 Resolution Paper</h3>
        <ul>
          <li>Must contain at least <strong>5 preambulatory</strong> and <strong>6 operative clauses</strong>.</li>
          <li>Sub-clauses must be structured logically (no single sub-points).</li>
        </ul>
      </section>

      <section>
        <h2>5. Electronic Device Policy</h2>
        <p>
          Devices may be used for MUN-related purposes only. Non-conference use during sessions is
          prohibited and may result in device privilege removal.
        </p>
      </section>

      <section>
        <h2>6. Safety & Security</h2>
        <ul>
          <li>Conference badges must be worn at all times.</li>
          <li>Participants must remain within approved conference areas.</li>
          <li>Weapons, alcohol, and illegal substances are strictly prohibited.</li>
          <li>All emergency instructions must be followed immediately.</li>
        </ul>
      </section>

      <section>
        <h2>7. Social Events & Off-Site Conduct</h2>
        <p>
          Participants represent their schools and OTTOMUN at all conference-related events. Any
          misconduct that harms the reputation of OTTOMUN is subject to disciplinary action.
        </p>
      </section>

      <section>
        <h2>8. Consequences for Violations</h2>
        <ul>
          <li>Formal warning.</li>
          <li>Loss of speaking/voting rights.</li>
          <li>Expulsion from committee or conference (no refund).</li>
          <li>Notification of school and faculty advisor.</li>
        </ul>
      </section>

      <section>
        <h2>9. Agreement</h2>
        <p>
          By attending OTTOMUN, all participants acknowledge and agree to follow this Code of
          Conduct.
        </p>

        <p><strong>— The Secretariat of OTTOMUN</strong></p>
        <p><em>Organized by Majole International Education</em></p>
      </section>
    </div>
  );
};

export default Conduct;
